import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deliverable-info',
  templateUrl: './deliverable-info.component.html',
  styleUrls: ['./deliverable-info.component.scss']
})
export class DeliverableInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
